import React from 'react';
import PropTypes from 'prop-types';
import ExternalLink from './externalLink';
import { Icon } from 'semantic-ui-react';
import { Img } from './img';
import '../components.gallery.scss';

function SelectableImage({ url, thumb, imageHeight, imageWidth, size, alt, onSelected, creditLink, creditName, onDelete, isBanner }) {
    let [height, setHeight] = React.useState(imageHeight);
    let [width, setWidth] = React.useState(imageWidth);

    React.useEffect(() => {
        if (onDelete) {
            let image = new Image();
            image.onload = () => {
                setHeight(image.height);
                setWidth(image.width);
            };
            image.src = url;
        }
        // eslint-disable-next-line
    }, [url]);

    const onClick = React.useCallback(() => {
        onSelected(url);
    }, [url]);

    return (
        <div className="wz-selectable-image">
            <div className={creditLink || creditName || onDelete ? 'wz-top-image-details' : ''}>
                {creditLink && creditName && (
                    <div className="wz-dimensions">
                        {width} * {height}
                    </div>
                )}
                {onDelete && (
                    <div className="wz-dimensions">
                        {width} * {height}
                    </div>
                )}
            </div>
            <Img src={thumb || url} alt={alt} onClick={onClick} />
            {creditLink && creditName && (
                <div className="wz-credit">
                    <ExternalLink href={`${creditLink}?utm_source=weeztarget&utm_medium=referral`}>{creditName}</ExternalLink>
                </div>
            )}
            {onDelete && (
                <div className="wz-bottom-image-details">
                    <div className="wz-size">{size} Ko</div>
                    <Icon className="wz-trash-icon" name="trash alternate outline" onClick={onDelete} />
                </div>
            )}
        </div>
    );
}

SelectableImage.propTypes = {
    alt: PropTypes.string,
    url: PropTypes.string.isRequired,
    thumb: PropTypes.string,
    onSelected: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    creditLink: PropTypes.string,
    creditName: PropTypes.string,
    imageHeight: PropTypes.number,
    imageWidth: PropTypes.number,
    size: PropTypes.number
};

SelectableImage.defaultProps = {
    alt: '',
    thumb: '',
    onDelete: null,
    creditLink: '',
    creditName: '',
    imageHeight: null,
    imageWidth: null,
    size: 0
};

export default SelectableImage;
